<template>
  <UContextMenu :items="logoContextMenu">
    <NuxtLink class="block h-full py-1.5" to="/">
      <ClientOnly>
        <img
          v-show="customImgString"
          class="h-full"
          :src="customImgString || ''"
        />
      </ClientOnly>
      <div v-show="!customImgString" class="font-sans text-xl">Timeplat.eu</div>
    </NuxtLink>
  </UContextMenu>
</template>

<script setup lang="ts">
import type { ContextMenuItem } from "@nuxt/ui";
import { ChangeLogoModal } from "#components";

const overlay = useOverlay();
const changeLogoModal = overlay.create(ChangeLogoModal);
const { $customLogo } = useNuxtApp();

onMounted(() => {
  $customLogo.onUpdate((str) => (customImgString.value = str));
});

const customImgString = ref($customLogo.getLogoDataUrl());

const logoContextMenu = computed<ContextMenuItem[][]>(() => [
  [
    {
      label: customImgString.value ? "Change custom logo" : "Add custom logo",
      class: "cursor-pointer",
      onSelect: async () => {
        const _result = await changeLogoModal.open({});
      },
    },
    {
      label: "Remove custom logo",
      class: "cursor-pointer",
      disabled: !customImgString.value,
      onSelect: async () => {
        $customLogo.reset();
      },
    },
  ],
]);
</script>
